export default __webpack_public_path__ + "static/media/square.342f4d60.png";